import {ClientSchemaField} from 'registry/field/FieldTable';
import * as net from 'util/Net';

export type CreateFieldMigrationData = Omit<ClientSchemaField, 'id' | 'dbId' | 'apiId' | 'cid'>;

export function createFieldMigration(
  sourceFieldId: string,
  destinationFieldConfig: CreateFieldMigrationData | null,
  destinationFieldId: string | null,
  locale: string | null
): Promise<{}> {
  return net.postJSONPromise({
    url: `/1/api/schema-field/${sourceFieldId}/migrations`,
    data: {field: destinationFieldConfig, destination_field_id: destinationFieldId, locale},
  });
}

export function rollbackFieldMigration(sourceFieldId: string): Promise<{}> {
  return net.postJSONPromise({
    url: `/1/api/schema-field/${sourceFieldId}/migrations/cancel`,
  });
}

export interface NameSpecifications {
  sourceFieldDisplayName: string;
  sourceFieldWarehouseName: string;
  destinationFieldDisplayName: string;
  destinationFieldWarehouseName: string;
}

export function publishFieldMigration(
  sourceFieldId: string,
  names: NameSpecifications,
  archiveSourceField: boolean
): Promise<{}> {
  return net.postJSONPromise({
    url: `/1/api/schema-field/${sourceFieldId}/migrations/publish`,
    data: {
      source_field_display_name: names.sourceFieldDisplayName,
      source_field_system_name: names.sourceFieldWarehouseName,
      destination_field_display_name: names.destinationFieldDisplayName,
      destination_field_system_name: names.destinationFieldWarehouseName,
      archive_source_field: archiveSourceField,
    },
  });
}
